export const socialProviders = {
  GOOGLE: 'Google',
  FACEBOOK: 'Facebook',
  APPLE: 'SignInWithApple',
};